export const selectAddresses = (state) => state.checkout.addresses.data;
//# sourceMappingURL=selectAddresses.js.map